export default __webpack_public_path__ + "static/media/02.c1569d70.jpg";